import React from 'react';
import './LoadingSpinner.css';

export default function LoadingSpinner({ label = 'Loading', className = '', size = 'md' }) {
  const wrapClass = ['ui-loading', className].filter(Boolean).join(' ');
  const spinnerClass = size === 'sm' ? 'ui-spinner ui-spinner-sm' : 'ui-spinner';

  return (
    <div className={wrapClass} role="status" aria-live="polite" aria-label={label}>
      <span className={spinnerClass} aria-hidden="true" />
    </div>
  );
}
